export default {
  'adminMarket': ['ADMIN', 'MODERATOR'],
  'adminUsers': ['ADMIN']
};